import { AutocompleteRenderInputParams, TextField, TextFieldProps } from "@mui/material";
import "./Search.css";

export const SearchHelper = {
    dateInputProps: (id: string) => {
        return { size: "small" as "small" | "medium" | undefined, id: id };
    },
    renderAutocompleteInput: (params: AutocompleteRenderInputParams, label: string) => {
        return <TextField label={label} className="autocomplete-width-18rem" {...params} />;
    },
};
